import { Component } from '@angular/core';


@Component({
  selector: 'lib-shared',
  standalone: true,
  imports: [],
  template: `
    <p>
      shared works!
    </p>
  `,
  styles: [
  ]
})
export class SharedComponent {

}
